import {
  defineNotificationWorkflow,
  notificationWorkflowKeyFromEnum,
} from '@app/modules/notifications/workflows/notification-workflow';
import { NotificationsSocialUploadCompletedNotificationDtoWorkflowKeyEnum } from '@mi-front/api-v2';
import { defineMessage } from 'react-intl';
import { getFragmentPublishPathFromKey } from './parse-fragment-upload-key';

function isHttpUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

const openVideoMessage = defineMessage({
  id: 'notifications.item.openVideo',
  defaultMessage: 'Ver video',
});

/**
 * Knock workflow: social upload completed.
 * Primary click opens the fragment publish page; secondary action opens the published video.
 */
export const socialUploadCompletedWorkflow = defineNotificationWorkflow({
  key: notificationWorkflowKeyFromEnum(
    NotificationsSocialUploadCompletedNotificationDtoWorkflowKeyEnum,
  ),
  category: 'social-upload',
  channels: { inApp: true, email: false },
  severity: 'success',
  preference: {
    title: defineMessage({
      id: 'notifications.preferences.workflow.socialUploadCompleted.title',
      defaultMessage: 'Publicación exitosa',
    }),
    description: defineMessage({
      id: 'notifications.preferences.workflow.socialUploadCompleted.description',
      defaultMessage: 'Cuando un video se publica correctamente en una red social',
    }),
  },
  actionUrl: (data) => getFragmentPublishPathFromKey(data.key),
  actions: (data) => {
    const url = data.videoUrl;
    if (!url || !isHttpUrl(url)) {
      return [];
    }
    return [
      {
        name: 'open_video',
        label: openVideoMessage,
        url,
      },
    ];
  },
});
